export const manualUploadAction = {
  setPdfPreviewUrl: (state, action) => {
    state.pdfPreviewUrl = action.payload;
  },

  setPdfFileNames: (state, action) => {
    state.pdfFileNames = action.payload;
  },

  setInOfficeFile: (state, action) => {
    state.inOfficeFile = action.payload;
  },

  setInOfficeFileName: (state, action) => {
    state.inOfficeFileName = action.payload;
  },

  setIsUploadingInOfficeFile: (state, action) => {
    state.isUploadingInOfficeFile = action.payload;
  },

  setSelectedBillingCodes: (state, action) => {
    state.selectedBillingCodes = action.payload;
  },

  setRemoteBillingCodeMapper: (state, action) => {
    state.remoteBillingCodeMapper = action.payload;
  },

  setIsExistingPatient: (state, action) => {
    state.isExistingPatient = action.payload;
  },

  setTransmissionType: (state, action) => {
    state.transmissionType = action.payload;
  },

  setSelectedPatient: (state, action) => {
    state.selectedPatient = action.payload;
  },

  setShowSwitchUserTypeModal: (state, action) => {
    state.showSwitchUserTypeModal = action.payload;
  },

  setShowCrossFacilityPatientWarningModal: (state, action) => {
    state.showCrossFacilityPatientWarningModal = action.payload;
  },

  setSelectedCrossFacilityPatient: (state, action) => {
    state.selectedCrossFacilityPatient = action.payload;
  },

  setShowCustomNotes: (state, action) => {
    state.showCustomNotes = action.payload;
  },

  setIsSubmitClicked: (state, action) => {
    state.isSubmitClicked = action.payload;
  },

  setIsSubmitting: (state, action) => {
    state.isSubmitting = action.payload;
  },

  setUploadReportId: (state, action) => {
    state.uploadReportId = action.payload;
  },

  setPatientManufacturers: (state, action) => {
    state.patientManufacturers = action.payload;
  },

  setPatientAdditionalManufacturers: (state, action) => {
    state.patientAdditionalManufacturers = action.payload;
  },

  setShowAddNewDeviceModal: (state, action) => {
    state.showAddNewDeviceModal = action.payload;
  },

  setIsInOfficeUpload: (state, action) => {
    state.isInOfficeUpload = action.payload;
  },

  setShowInOfficeUploadPatientFoundDetails: (state, action) => {
    state.showInOfficeUploadPatientFoundDetails = action.payload;
  },

  setInOfficeUploadPatientDetails: (state, action) => {
    state.inOfficeUploadPatientDetails = action.payload;
  },

  setExistingPatientFieldValues: (state, action) => {
    state.existingPatientFieldValues = action.payload;
  },

  setSimilarPatientsFromInOfficeFile: (state, action) => {
    state.similarPatientsFromInOfficeFile = action.payload;
  },

  setInOfficeUploadPatientInformationForManualUpload: (state, action) => {
    state.inOfficeUploadPatientInformationForManualUpload = action.payload;
  },

  setReportTemplates: (state, action) => {
    state.reportTemplates = action.payload;
  },

  setShowReportTemplateUpdateAlert: (state, action) => {
    state.showReportTemplateUpdateAlert = action.payload;
  },

  setPatientInfoToUpdate: (state, action) => {
    state.patientInfoToUpdate = action.payload;
  },

  setShowMissingBillingCodeTemplateModal: (state, action) => {
    state.showMissingBillingCodeTemplateModal = action.payload;
  },

  setMissingTemplateBillingCodes: (state, action) => {
    state.missingTemplateBillingCodes = action.payload;
  },

  setExtractedPdfData: (state, action) => {
    state.extractedPdfData = action.payload;
  },
};
